import React, { ReactElement } from 'react';
import { Loader, Message } from 'semantic-ui-react';

type Props<T> = {
  // A TanStack or an Apollo query
  query: { data: T | undefined; error?: { message: string } | null };
  // « factures »
  label: string;
  children: (data: T) => ReactElement;
};

export const QueryResult = <T,>({
  query,
  label,
  children,
}: Props<T>): ReactElement => {
  if (query.error) {
    return (
      <Message negative>
        Impossible de récupérer les {label} : {query.error.message}
      </Message>
    );
  }

  if (!query.data) {
    return (
      <Loader
        size="large"
        active
        inline="centered"
        content={`Chargement des ${label}...`}
      />
    );
  }

  return children(query.data);
};
